// src/components/InvestmentModal.js - CORRIGÉ POUR UTILISER LA ROUTE /subscribe

import React from 'react';
import { useNavigate } from 'react-router-dom';
import './InvestmentModal.css';
import { FaTimes } from 'react-icons/fa'; 

// Suppression de la prop 'accentColor' pour une couleur d'accentuation standardisée
const InvestmentModal = ({ title, amounts, onClose, referralLink }) => {
    const navigate = useNavigate();

    const handleSelectAmount = (amount) => {
        
        // 1. DÉFINITION DE LA ROUTE COMMUNE : /subscribe
        // On encode le titre pour s'assurer qu'il ne contient pas de caractères non valides dans l'URL.
        let url = `/subscribe?plan=${encodeURIComponent(title)}&amount=${amount}`;
        
        // 2. Ajout du code de parrainage (utilisant 'referral' pour correspondre à InvestmentConfirmation.js)
        if (referralLink) {
            // Utiliser le paramètre 'referral' pour uniformiser avec le flux de parrainage
            url += `&referral=${encodeURIComponent(referralLink)}`;
        }
        
        // 3. Redirection vers la page de confirmation
        navigate(url);
        onClose();
    };

    return (
        <div className="modal-backdrop">
            <div className="modal-content"> 
                
                <button className="close-button" onClick={onClose}>
                    <FaTimes /> 
                </button>
                
                <h4 className="text-center mb-4">{title}</h4>
                
                <div className="amount-grid">
                    {amounts.map((amount, index) => {
                        return (
                            <button 
                                key={index}
                                className="amount-btn" 
                                onClick={() => handleSelectAmount(amount)}
                            >
                                {amount.toLocaleString()} FCFA
                            </button>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default InvestmentModal;